export default "__VITE_ASSET__77d2f36b__"